import {
  IS_EMPTY_ACCOUNT,
  GET_CONFIG,
  GET_USER_DATA,
  ADD_MEDIAS_DATA,
  UPDATE_MEDIAS_PAGINATION,
  ON_CONNECT,
  ON_CONNECT_BUSINESS,
  ON_DISCONNECT,
  SET_PROFILE_HEADER_HEIGHT,
  SET_TITLE_HASHTAG_HEIGHT,
  IS_MOBILE,
  SET_APP_STATE,
  IS_APP_LOADING,
  SET_STORY,
  SET_HASHTAG_DATA,
  ADD_HASHTAGS_DATA,
  DEFAULT_TOP_PADDING_HEADER_DESK,
  DEFAULT_LEFT_PADDING_HEADER_DESK,
  DEFAULT_PADDING_HEADER_MOBILE,
  UPDATE_HASHTAG,
  ON_ADD_HASHTAG,
  ON_ADD_DEFAULT_HASHTAG,
  UPDATE_MEDIA_LINKS,
  HASHTAGS_LOADING,
  SET_IS_CONNECT,
  SET_TEMPLATE_ACCOUNT,
  MEDIAS_DATA_ERROR,
  ON_CHANGE_VIEW_MODE,
  LOGIN_ERROR,
} from '../constants';

const initData = {
  user: {},
  medias: [],
  mediasError: null,
  hashtags: [],
  defaultHashtags: [],
  hashtagsData: [],
  paginationMedias: {},
  hashtagsLoading: false,
  defaultIndex: 0,
  defaultMedia: {},
  userDBData: {},
  isEmptyAccount: null,
};

const initState = {
  isMobile: false,
  isLoading: false,
  isLoadingMedias: false,
  isConnected: null,
  isBusinessApp: true,
  profileHeaderHeight: null,
  titleHashtagHeight: 0,
  stories: [],
  headerTopPaddingDesk: DEFAULT_TOP_PADDING_HEADER_DESK,
  headerLeftPaddingDesk: DEFAULT_LEFT_PADDING_HEADER_DESK,
  headerPaddingMobile: DEFAULT_PADDING_HEADER_MOBILE,
  ...initData,
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_CONFIG:
      return {
        ...state,
        config: action.payload,
      };
    case IS_MOBILE:
      return {
        ...state,
        isMobile: action.payload,
      };
    case IS_APP_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        isLoadingMedias: action.payload,
      };
    case ON_CONNECT_BUSINESS:
      return {
        ...state,
        ...initData,
        ...action.payload,
        isBusinessApp: true,
        loginError: null,
      };
    case ON_DISCONNECT:
      return {
        ...state,
        accessToken: null,
        userId: null,
        isConnected: false,
        isBusinessApp: true,
        stories: [],
        ...initData,
      };
    case ON_CONNECT:
      return {
        ...state,
        ...initData,
        ...action.payload,
        isBusinessApp: false,
        loginError: null,
      };
    case SET_PROFILE_HEADER_HEIGHT:
      return {
        ...state,
        profileHeaderHeight: action.payload,
      };
    case SET_TITLE_HASHTAG_HEIGHT:
      return {
        ...state,
        titleHashtagHeight: action.payload,
      };
    case GET_USER_DATA:
      return {
        ...state,
        user: action.payload,
        isLoading: false,
      };
    case ADD_MEDIAS_DATA:
      return {
        ...state,
        medias: state.medias.concat(action.payload),
        defaultMedia: action.payload[0].originalData,
        isLoadingMedias: false,
      };
    case IS_EMPTY_ACCOUNT:
      return {
        ...state,
        isEmptyAccount: true,
        isLoadingMedias: false,
      };
    case UPDATE_MEDIAS_PAGINATION:
      return {
        ...state,
        paginationMedias: action.payload,
      };
    case SET_STORY:
      return {
        ...state,
        stories: action.stories,
      };
    case SET_HASHTAG_DATA:
      return {
        ...state,
        hashtagsData: action.payload,
        hashtagsLoading: false,
      };
    case ADD_HASHTAGS_DATA:
      return {
        ...state,
        hashtagsData: state.hashtagsData.concat(action.payload),
        hashtagsLoading: false,
      };
    case SET_APP_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_HASHTAG:
      return {
        ...state,
        hashtags: action.payload || [],
      };
    case ON_ADD_HASHTAG:
      return {
        ...state,
        hashtags: action.payload,
      };
    case ON_ADD_DEFAULT_HASHTAG:
      return {
        ...state,
        defaultHashtags: action.payload,
      };
    case UPDATE_MEDIA_LINKS:
      return {
        ...state,
        mediaLinksMap: action.payload,
      };
    case HASHTAGS_LOADING:
      return {
        ...state,
        hashtagsLoading: true,
      };
    case SET_IS_CONNECT:
      return {
        ...state,
        isConnected: action.payload,
      };
    case SET_TEMPLATE_ACCOUNT:
      return {
        ...state,
        isConnected: false,
        templateId: action.payload,
      };
    case MEDIAS_DATA_ERROR:
      return {
        ...state,
        isLoadingMedias: false,
        mediasError: action.payload,
      };
    case ON_CHANGE_VIEW_MODE:
      return {
        ...state,
        viewMode: action.payload,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        loginError: action.payload,
      };
    default:
      return state;
  }
};
